import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import {DOMAIN_ACTIVE, DOMAIN_NOT_VERIFIED, DOMAIN_REJECTED, DOMAIN_UNDER_APPROVAL,DOMAIN_EVALUATION} from './table-domain-status';

@Component({
  selector: 'app-table-domain-status',
  template: `
    <div class="status-title d-flex align-items-center">
      <span class="status-circle-main status-circle" ngClass="{{statusClass}} mr-2"><span class="status-circle" ngClass="{{statusClass}}"></span></span>
      {{statusText}}
      <span *ngIf="statusClass === 'rejected'">
        <i
          class="nxt-ml-10 nxticon-information"
          [ngbTooltip]="rejectionReasonsTpl"
          placement="auto"
          container="body"
          tooltipClass="rejection-reasons-tooltip"
        ></i>
        <ng-template #rejectionReasonsTpl>
          <div class="mat-tooltip-custom">
            <div class="text-align-left nxt-p-10" *ngIf="reasonMessages && reasonMessages.length; else noReasons">
              <div class="font-weight-semibold mb-1 font-color-error">Rejection reason: <span class="font-color-white font-weight-normal"> Verification checks got failed</span> </div>
              <ul class="mb-0 pl-3">
                <li *ngFor="let reason of reasonMessages">{{ reason }}</li>
              </ul>
              <div class="mt-2 font-weight-semibold">
                Sender domain: <span class="font-color-white font-weight-normal">{{rowData.domain}}</span>
              </div> 
              <div class="mt-2 font-color-gray font-weight-normal nxt-font-12">
                Please contact our helpdesk team for more information and share a snapshot of the rejection reason(s).
              </div>
            </div>
            <ng-template #noReasons>
              <span class="font-weight-semibold mb-1">No rejection reasons.</span>
            </ng-template>
          </div>
        </ng-template>
      </span>

      <div class="status-info">
        <a class="status-link text-link" href="#" (click)="onIcon1Click()" [class.disabled]="statusLinkMode" id="lnkAction">{{statusLinkText}}</a>
        <i *ngIf="statusLinkMode" class="icon-success" ngbTooltip="This domain can be managed only on the old Pepipost dashboard"></i>
      </div>
    </div>
  `,
  styleUrls: ['./table-domain-status.component.scss']
})
export class TableDomainStatusComponent implements ViewCell, OnInit {

  // renderValue: boolean; 

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() icon1Click: EventEmitter<any> = new EventEmitter();

  statusText: string;
  statusLinkText: string;
  statusLinkMode: boolean;
  statusClass: string;
  reasonMessages: any[];

  ngOnInit() {
    if (+this.rowData.status === 3) {
      this.statusText = DOMAIN_ACTIVE;
      this.statusLinkText = 'Test mail to get started';
      this.statusClass = 'active';
    } else if (+this.rowData.status === 1) {
      this.statusText = DOMAIN_UNDER_APPROVAL;
      //this.statusLinkText = 'Fast Track the process';
      this.statusLinkText = '';
      this.statusClass = 'under-approval';
    } else if (+this.rowData.status === 2) {
      this.statusText = DOMAIN_REJECTED;
      this.statusLinkText = 'Learn more';
      this.statusClass = 'rejected';
    } else if (+this.rowData.status === 0) {
        if(this.rowData.version.toLowerCase() === "v3"){
          if(+this.rowData.mode !== 1 && +this.rowData.custom!==1 && +this.rowData.inbound !== 1 ){
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify Custom Env, DKIM';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.custom!==1 && +this.rowData.inbound !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify Custom Env';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.custom!==1 && +this.rowData.mode !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify Custom Env and DKIM';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.mode!==1 && +this.rowData.inbound !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify DKIM';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.mode !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify DKIM';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.inbound !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
              this.statusLinkText = 'Verify Inbound';
              this.statusClass = 'not-verified';
          }else if (+this.rowData.custom!==1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify Custom env';
            this.statusClass = 'not-verified';
          }else { // (+this.rowData.active !== 1)
            this.statusText = DOMAIN_EVALUATION;
            this.statusLinkText = 'Answer domain queries';
            this.statusClass = 'evaluation';
          }
        }else{
          if (+this.rowData.active !== 1 && +this.rowData.mode !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify SPF and DKIM';
            this.statusClass = 'not-verified';
          }else if (+this.rowData.mode !== 1) {
            this.statusText = DOMAIN_NOT_VERIFIED;
              this.statusLinkText = 'Verify CNAME';
              this.statusClass = 'not-verified';
          }else if (+this.rowData.active === 0) {
            this.statusText = DOMAIN_NOT_VERIFIED;
            this.statusLinkText = 'Verify SPF';
            this.statusClass = 'not-verified';
          }else { // (+this.rowData.active !== 1)
            this.statusText = DOMAIN_EVALUATION;
            this.statusLinkText = 'Answer domain queries';
            this.statusClass = 'evaluation';
          }
      }
     
    } else { // (+this.rowData.active !== 1)
      this.statusText = DOMAIN_NOT_VERIFIED;
      this.statusLinkText = 'Verify CNAME';
      this.statusClass = 'not-verified';
    }
    this.statusLinkMode = this.rowData.action.toLowerCase() === 'true' ? true : false;
    // Collect all the reasons from rowData.reason (if available) into an array of strings
    this.reasonMessages = [];
    if (Array.isArray(this.rowData?.reason)) {
      this.reasonMessages = this.rowData.reason.map(r => r.reason);
    }
  }

  onIcon1Click() {
    this.rowData.domain_status = this.statusText;
    this.icon1Click.emit(this.rowData);
    return false;
  }
}
